export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER= 'LOGIN_USER';
export const CHANGE_PASSWORD='CHANGE_PASSWORD';

